import store from '@/store'

export default{
  inserted(el, binding, vnode) {
    const { value } = binding;
    const permissionBtns = store.getters && store.getters.permission_btnList;
    if (value && typeof value === 'string' && value.length > 0) {
      const hasPermission = permissionBtns.includes(value);
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`need btn! Like v-permission="productCate:list"`)
    }
  }
}


// WEBPACK FOOTER //
// ./src/directive/permission/permission.js